<template>
    <WellScanSearch/>
</template>

<script>
// @ is an alias to /src
import WellScanSearch from '@/components/WellScanSearch.vue'

export default {
  name: 'home',
  components: {
    WellScanSearch
  }
}
</script>
